/* ========================================================================
   Lax
 ========================================================================== */

app.lax = (function () {
  'use strict';

  let showCompactBrand = false;
  let resizedNavBar = false;

  function init() {
    lax.init();

    const navBar = document.querySelector('[data-nav-bar]');

    // Add a driver that we use to control our animations
    lax.addDriver('scrollY', function () {
      return window.scrollY;
    });

    lax.addElements(
      '[data-lax-brand]',
      {
        scrollY: {
          translateY: [
            {
              992: [100, 350, 500, 750],
              1200: [150, 400, 500, 750],
              1400: [250, 500, 500, 750],
            },
            [0, -250, -250, 0],
          ],
        },
      },
      {
        onUpdate: function (driverValues, domElement) {
          const scrollY = driverValues.scrollY[0];

          if (scrollY >= 500 && showCompactBrand === false) {
            domElement.classList.add('is-compact');
            showCompactBrand = true;
          } else if (scrollY < 500 && showCompactBrand === true) {
            domElement.classList.remove('is-compact');
            showCompactBrand = false;
          }

          if (scrollY >= 40 && resizedNavBar === false) {
            navBar.classList.add('is-compact');
            resizedNavBar = true;
          } else if (scrollY < 40) {
            navBar.classList.remove('is-compact');
            resizedNavBar = false;
          }
        },
      }
    );

    lax.addElements('[data-lax-nav]', {
      scrollY: {
        translateY: [
          {
            1200: [150, 400],
            1400: [250, 500],
          },
          [0, -250],
        ],
      },
    });

    // lax.addElements('[data-lax-hero]', {
    //   scrollY: {
    //     opacity: [
    //       {
    //         768: [0, 400],
    //         992: [0, 500],
    //         1200: [0, 600],
    //         1400: [0, 700],
    //         1600: [0, 800],
    //       },
    //       [1, 0.25],
    //     ],
    //     scale: [
    //       {
    //         768: [0, 400],
    //         992: [0, 500],
    //         1200: [0, 600],
    //         1400: [0, 700],
    //         1600: [0, 800],
    //       },
    //       [1, 1.25],
    //     ],
    //   },
    // });

    lax.addElements('[data-lax-hero]', {
      scrollY: {
        blur: [
          {
            768: [0, 400],
            992: [0, 500],
            1200: [0, 600],
            1400: [0, 700],
            1600: [0, 800],
          },
          [0, 20],
        ],
      },
    });

    let featuresBottom = 0;
    const jobFeatures = document.querySelector('[data-job-features]');
    const body = document.querySelector('body');

    if (jobFeatures) {
      featuresBottom =
        (body.getBoundingClientRect().top -
          jobFeatures.getBoundingClientRect().bottom) *
        -1;
    }

    lax.addElements('[data-lax-job-apply]', {
      scrollY: {
        translateY: [
          {
            680: [
              featuresBottom - 100,
              featuresBottom - 50,
              'pageHeight - screenHeight - 50',
              'pageHeight - screenHeight',
            ],
            1600: [
              300,
              350,
              'pageHeight - screenHeight - 50',
              'pageHeight - screenHeight',
            ],
          },
          [50, 0, 0, 50],
        ],
      },
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
